import $ from 'jquery';

export default function edvFlipbox() {

        $('.flipbox-inner').click(function() {
            $(this).toggleClass('flipped');
        });


}
